var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.76562H9.75V3C9.75 2.72344 9.52656 2.5 9.25 2.5H2.875V1.875C2.875 1.80625 2.81875 1.75 2.75 1.75H1.875C1.80625 1.75 1.75 1.80625 1.75 1.875V14.125C1.75 14.1938 1.80625 14.25 1.875 14.25H2.75C2.81875 14.25 2.875 14.1938 2.875 14.125V10H6.75V11.7656C6.75 12.0422 6.97344 12.2656 7.25 12.2656H13.75C14.0266 12.2656 14.25 12.0422 14.25 11.7656V5.26562C14.25 4.98906 14.0266 4.76562 13.75 4.76562ZM2.875 8.875V3.625H8.625V8.875H2.875ZM13.125 11.1406H7.875V10H9.625C9.69375 10 9.75 9.94375 9.75 9.875V5.89062H13.125V11.1406Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3a69554558b64ccb7457ed9bb41e4bfb.svg";
export { ForwardRef as ReactComponent };